import { gameApi } from './game'
import { gameBuilderApi } from './gameBuilder'

export const api = {
  gameBuilder: gameBuilderApi,
  game: gameApi,
}
